module.exports = __webpack_public_path__ + "static/img/projectApply.a3b67a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projectApply.png
// module id = 0WSo
// module chunks = 2